// [@vidstack/eliza] THIS FILE IS AUTO GENERATED - SEE `eliza.config.ts`

import "../../define/vds-time.js";
import * as React from "react";
import { createComponent } from "../lib/index.js";
import { TimeElement } from "../../ui/time/index.js";

const EVENTS = {} as const;

/** Outputs a media duration (eg: `currentTime`, `duration`, `bufferedAmount`, etc.) value as time
formatted text. */
const Time = createComponent(React, "vds-time", TimeElement, EVENTS, "Time");

export default Time;
